import Step0 from "modules/claims/components/StepForm/Step0"

const Claims = () => <Step0 />

export default Claims
